import { clsx } from 'clsx'
import { type JSX } from 'react'

import { IconClose } from '@redteclab/icons'

import { useLocaleContext } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config/context/globalConfigContext'
import { TENANT } from '../../tenant/tenantTypes'

type NewsletterModalTitleProps = {
  onModalClose: () => void
}

export const NewsletterModalTitle = ({
  onModalClose,
}: NewsletterModalTitleProps): JSX.Element => {
  const closeLabel = useLocaleContext().dialog.close
  const { tenant } = useGlobalConfigContext()

  return (
    <div className="relative">
      <button
        aria-label={closeLabel}
        className={clsx(
          'absolute right-3 top-3 p-0 hover:text-dark-hover-brand active:text-dark-pressed-brand',
          tenant === TENANT.IT
            ? 'text-light-primary-strong'
            : 'text-dark-primary-max',
        )}
        onClick={onModalClose}
        type="button"
      >
        <IconClose aria-hidden className="size-8" />
      </button>
    </div>
  )
}
